var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItPasswordVisible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,11.5C19,6.1,12.4,3.9,7,6.7c-2.1,1.1-3.7,2.7-4.8,4.8L2,12l0.2,0.5c2.8,5.4,9.4,7.6,14.8,4.8 c2.1-1.1,3.7-2.7,4.8-4.8L22,12L21.8,11.5z M12,17.5c-3.8,0-7.2-2.1-8.9-5.5C4.8,8.6,8.2,6.5,12,6.5c3.8,0,7.2,2.1,8.9,5.5 C19.2,15.4,15.8,17.5,12,17.5z M12,8c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S14.2,8,12,8z M12,15c-1.7,0-3-1.3-3-3s1.3-3,3-3 s3,1.3,3,3c0.1,1.6-1.2,2.9-2.8,3C12.1,15,12.1,15,12,15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItPasswordVisible);
export default __webpack_public_path__ + "static/media/it-password-visible.f96c3098.svg";
export { ForwardRef as ReactComponent };